import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const RiskGaugeMedium = () => (
  <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(-2.4867 -6.5205)">
      <path
        d="M9.64247 31.0099C9.41879 31.3973 8.92184 31.532 8.54854 31.2855C7.17933 30.3814 5.98444 29.2339 5.02434 27.8978C3.90645 26.3421 3.13246 24.5663 2.75381 22.6884C2.37515 20.8105 2.40051 18.8735 2.82819 17.0061C3.1955 15.4023 3.85236 13.8815 4.76422 12.5174C5.01283 12.1455 5.52317 12.0772 5.8795 12.3476C6.23583 12.6181 6.30289 13.1248 6.05733 13.4987C5.28276 14.6782 4.72329 15.9881 4.4073 17.3678C4.03094 19.0111 4.00863 20.7156 4.34184 22.3682C4.67506 24.0207 5.35617 25.5834 6.33991 26.9525C7.16584 28.1019 8.18921 29.0926 9.36032 29.8798C9.7316 30.1293 9.86614 30.6224 9.64247 31.0099Z"
        fill="#09DE85"
        opacity="0.3"
      />
      <g opacity="0.4" filter="url(#risk-gauge-medium-filter-yellow)">
        <path
          d="M7.06238 12.1793C6.39022 11.5888 6.31818 10.5566 6.9849 9.95999C8.00434 9.04771 9.15892 8.29355 10.4105 7.72581C12.1551 6.93442 14.0481 6.52338 15.9638 6.52002C17.8795 6.51666 19.774 6.92106 21.5213 7.70634C22.7749 8.26968 23.9321 9.01979 24.9547 9.92849C25.6235 10.5228 25.5551 11.5552 24.885 12.148C24.2149 12.7409 23.1979 12.6663 22.5071 12.0978C21.8049 11.5199 21.0271 11.0364 20.1932 10.6616C18.8652 10.0648 17.4254 9.75746 15.9695 9.76002C14.5135 9.76257 13.0748 10.075 11.7489 10.6764C10.9164 11.0541 10.1403 11.5403 9.44009 12.1207C8.75124 12.6916 7.73455 12.7698 7.06238 12.1793Z"
          fill="#FFCA1B"
        />
      </g>
      <path
        d="M10.0812 30.2499C9.61523 31.057 8.57522 31.3415 7.8325 30.7786C6.76033 29.9659 5.8131 28.9955 5.02434 27.8978C3.90645 26.3421 3.13246 24.5663 2.75381 22.6884C2.37515 20.8105 2.40051 18.8735 2.82819 17.0061C3.12995 15.6886 3.62714 14.4269 4.3006 13.2623C4.76712 12.4554 5.83611 12.3147 6.57846 12.8782C7.32081 13.4416 7.45131 14.4957 7.0188 15.3212C6.61609 16.0899 6.31278 16.9092 6.11801 17.7596C5.79725 19.1601 5.77823 20.6128 6.06222 22.0213C6.34621 23.4297 6.9267 24.7616 7.76512 25.9284C8.27422 26.6368 8.87133 27.2746 9.54044 27.8271C10.2591 28.4206 10.5472 29.4428 10.0812 30.2499Z"
        fill="#E0E1E5"
      />
      <path
        d="M25.2135 12.6434C25.9415 12.0614 27.0137 12.1752 27.5004 12.97C28.203 14.1173 28.7318 15.366 29.0666 16.6755C29.5412 18.5315 29.6154 20.4673 29.2842 22.3541C28.9529 24.241 28.2239 26.0357 27.1456 27.6191C26.3847 28.7363 25.4623 29.7302 24.4109 30.5697C23.6826 31.1512 22.6358 30.893 22.1496 30.0979C21.6634 29.3027 21.9257 28.2736 22.6291 27.6622C23.2841 27.093 23.865 26.4404 24.3561 25.7193C25.1648 24.5318 25.7116 23.1857 25.96 21.7706C26.2084 20.3554 26.1528 18.9036 25.7968 17.5116C25.5807 16.6664 25.2568 15.855 24.8349 15.0967C24.3817 14.2823 24.4856 13.2254 25.2135 12.6434Z"
        fill="#E0E1E5"
      />
      <path
        d="M7.1131 12.2238C6.41293 11.6087 6.33772 10.5331 7.03532 9.9151C8.04235 9.02295 9.1795 8.28421 10.4105 7.72581C12.1551 6.93442 14.0481 6.52338 15.9638 6.52002C17.8795 6.51666 19.774 6.92106 21.5213 7.70634C22.7542 8.26042 23.894 8.99516 24.9041 9.88377C25.6039 10.4993 25.5325 11.5752 24.8344 12.1927C24.1364 12.8103 23.0773 12.7317 22.3525 12.1459C21.6776 11.6003 20.9336 11.1424 20.1379 10.7848C18.8274 10.1958 17.4065 9.8925 15.9697 9.89502C14.5329 9.89753 13.1132 10.2058 11.8047 10.7994C11.0102 11.1598 10.2678 11.6204 9.59487 12.1682C8.87213 12.7566 7.81326 12.8389 7.1131 12.2238Z"
        fill="#FFCA1B"
      />
    </g>
    <g transform="translate(11.55 13.56) rotate(-111.25 1.92 1.92)">
      <path
        d="M1.92285 0C2.80232 0.0000902861 3.54182 0.59125 3.77051 1.39746L11.3584 6.1416L2.85742 3.60156C2.5806 3.75602 2.26235 3.84567 1.92285 3.8457C0.861069 3.8457 0.000109 2.98461 0 1.92285C0 0.861002 0.861002 0 1.92285 0Z"
        fill="#313036"
      />
    </g>
    <defs>
      <filter
        id="risk-gauge-medium-filter-yellow"
        x="0"
        y="0"
        width="31.9433"
        height="19.107"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="3.26" result="effect1_foregroundBlur_0_4" />
      </filter>
    </defs>
  </svg>
)

export default withDefaultStyles(RiskGaugeMedium)
